import { apiPost } from '@/shared/utils/requestBuilder';

import type { CitacaoRegistrada, RegistrarCitacaoArgs } from '../../types/registroCitacao';
import { handleError, unwrapData } from '../services';

export const registroCitacaoService = {
  registrar: async ({
    processoId,
    parteArbitralId,
    input,
  }: RegistrarCitacaoArgs): Promise<CitacaoRegistrada> => {
    const response = await apiPost(
      `/admin/arbitral/processos/${encodeURIComponent(processoId)}/partes/${encodeURIComponent(parteArbitralId)}/citacao/registrar`,
      input,
    );
    // `ErroHttp` com o `code` do core: as recusas do registro são distinguidas pelo código, e não
    // pelo texto, que carrega ids e é diagnóstico.
    if (!response.ok) await handleError(response, 'Erro ao registrar a citação');
    return unwrapData<CitacaoRegistrada>((await response.json()) as unknown);
  },
};
